import React from 'react';
import {Button, List, ListItem, ListItemButton, ListItemText} from '@mui/material';
import {Link} from 'react-router-dom';

const RightDrawer = ({categories, slug}: {categories: {className: string}[]; slug: string | undefined}) => {
  return (
    <List>
      {categories.map((category) => (
        <ListItem key={category.className} disablePadding>
          <ListItemButton component={Link} to={`/${slug}/${category.className}`}>
            <ListItemText primary={category.className} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default RightDrawer;
